import {
    ADD_ERROR, CLEAR_ERROR
} from './constants';
import Request from "../../../utils/request";

export const addError = (code, message, errorType) => ({
    type: ADD_ERROR,
    code,
    errorType,
    message
});

export const clearError= () => ({
    type: CLEAR_ERROR
});


/**
 *  ASYNC ACTIONS
 */

export const getRandomGif = () => () => {
    const giphy = {
        baseURL: "https://api.giphy.com/v1/gifs/",
        key: "dc6zaTOxFJmzC",
        tag: "fail",
        type: "random",
        rating: "pg"
    };

    let giphyURL = encodeURI(
        giphy.baseURL +
        giphy.type +
        "?api_key=" +
        giphy.key +
        "&tag=" +
        giphy.tag +
        "&rating=" +
        giphy.rating
    );

    let request = new Request();

    return request.get(giphyURL)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        })
};

export const setError = (code, message, errorType) => (dispatch, getStore) => {
    let errors = getStore().errors;

    switch(code) {
        case 401:
            if(errors.code !== 401) {
                dispatch(addError(code, message, errorType));
            }
            break;
        default:
            if(errors.code !== 401 && errors.code !== code && errors.errorType !== errorType) {
                dispatch(addError(code, message, errorType));
            }
    }
};



// WEBPACK FOOTER //
// ./src/containers/Errors/store/actions.js